import useSWR from 'swr';

const useEdition = (eventId, editionId) => {
  const { data, error, mutate } = useSWR(
    Boolean(eventId && editionId)
      ? `/event/${eventId}/edition/${editionId}`
      : null
  );

  return {
    edition: data,
    isLoading: !error && !data,
    error,
    mutate,
  };
};

export { useEdition };
